<template>
  <div>
    <div class="relevant" ref="relevant" :class="{ openClass: !isBoolean }">
      <h1 v-if="moduleIsShow == 'true'" @click="addCalss('AlkDetails')">
        <span>{{ title }}</span>
        <i class="iconfont icon-right_medium"></i>
      </h1>
      <h1 v-else @click="addCalss('AlkDetails')">
        <p>
          {{ title }}
          <span
            v-if="moduleAnnotation != ''"
            class="ts-info iconfont icon-zhu"
            @click.stop="isNotes()"
          >
          </span>
        </p>

        <i
          class="iconfont"
          :class="isBoolean ? 'icon-up_medium' : 'icon-down_medium'"
        ></i>
      </h1>
      <div v-if="moduleIsShow == 'false'" class="show-box"></div>
      <div class="text-content" v-if="moduleIsShow == 'false'">
        <Empty v-if="currentPageData == ''" />
        <van-list
          v-else
          v-model="loading"
          :finished="finished"
          finished-text=""
        >
          <div
            class="Alk"
            v-for="(item, index) in currentPageData"
            :key="index"
          >
            <div class="title">{{ item.geneName }}</div>
            <div class="content">
              <div class="text-content-alk">
                <p>突变类型</p>
                <h2>{{ item.mutationType }}</h2>
              </div>
              <div class="text-content-alk">
                <p>检测结果</p>
                <h2 class="result">
                  {{ item.testResult }}
                </h2>
              </div>
              <div class="text-content-alk">
                <p>解析</p>
                <h2>
                  {{ item.analysis }}
                </h2>
              </div>
            </div>
          </div>
        </van-list>

        <!-- <div v-if="isFalse && currentPageData.length >= 4">
          <div
            v-if="currentPageData.length == productList.length"
            class="openStyle"
            @click="close()"
          >
            收起 <i class="iconfont icon-up_medium"></i>
          </div>
          <div
            v-if="currentPageData.length < productList.length"
            class="openStyle"
            @click="openList()"
          >
            展开 <i class="iconfont icon-down_medium"></i>
          </div>
        </div>
        <p class="null-p" v-if="productList.length <= 0 && finished == true">
          未检测到与肿瘤遗传易感性相关的致病及可能致病突变。
        </p>
        <div class="_btn">
          <button @click="handleDetails()">
            胚系变异检出详情<i class="iconfont icon-right_medium"></i>
          </button>
        </div> -->
      </div>
    </div>
    <!-- 注释弹框 -->
    <Notes ref="child" :notesText="notesText" />
  </div>
</template>
<script>
import { getAlk } from "@/api/reportQuery";

// import Notes from "@/components/notes.vue";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import { Toast } from "vant";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
      default: "重要基因检测结果及相关解析",
    },
    moduleIsShow: {
      type: String,
      default: "true",
    },
    templateIsShow: {
      type: String,
      default: "true",
    },
    templateId: {
      type: String,
      default: 10,
    },
  },
  // components: {
  //   Notes,
  // },
  data() {
    return {
      isFalse: false,
      isBoolean: this.templateIsShow == "false" ? false : true,
      activeNames: ["1"],
      isClass: false,
      loading: false,
      finished: false,
      // 遗传易感相关变异数据

      notesText: {
        h1: this.title,
        p: this.moduleAnnotation,
      },
      productList: [], //所有数据
      totalPage: 1, // 统共页数，默认为1
      currentPage: 1, //当前页数 ，默认为1
      pageSize: 4, // 每页显示数量
      currentPageData: [], //当前页显示内容
      // labOriginalSampleNo:"F210422168T",
      // productId:"fwa-p825"
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    ...mapMutations("embry", ["setParams"]),
    isNotes() {
      if (this.$route.query.userAgent == "wxWeb") {
        this.$refs.child.ishow();
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "notes",
          notesText: this.notesText,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "notes",
            notesText: this.notesText,
            type: "",
          })
        );
      }
    },
    handleDetails() {
      let params = {
        name: "embryoAll",
        type: "",
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(params);
      } else {
        window.android.JSCallNative(JSON.stringify(params));
      }
    },
    addCalss(name) {
      let param = {
        name: name,
        moduleId: this.templateId,
        type: "",
      };
      if (this.moduleIsShow == "true") {
        if (this.$route.query.userAgent == "wxWeb") {
          wx.miniProgram.navigateTo({
            url: "/packageWebView/pages/alk-details/alk-details?moduleId=" + this.templateId,
          });
        } else if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage(param);
        } else {
          window.android.JSCallNative(JSON.stringify(param));
        }
      } else {
        this.isBoolean = !this.isBoolean;
        // Boolean(this.templateIsShow) = !Boolean(this.templateIsShow);
      }

      // this.isClass = !this.isClass;
    },
    close() {
      console.log(this.currentPage);
      this.currentPage = 1;

      this.currentPageData = this.currentPageData.slice(0, 4);
    },
    openList() {
      if (this.currentPage == this.totalPage) return;
      this.currentPage++;
      this.openData();
    },
    /**处理展开收起数据 */
    openData() {
      this.totalPage = Math.ceil(this.productList.length / this.pageSize);
      console.log(this.totalPage);
      // 计算得0时设置为1
      this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
      let begin = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.currentPageData = [
        ...this.currentPageData,
        ...this.productList.slice(begin, end),
      ];
    },
    /**akl接口 */
    async getDataList() {
      try {
        let { data } = await getAlk({
          labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
          productCode: this.publicParams.productId,
          moduleId: this.templateId,
          current: 1,
          pageSize: 40,
        });
        this.productList = data.records;
        console.log(this.productList, "22233333");
        this.openData();

        // 加载状态结束
        this.loading = false;
        this.finished = true;
        this.isFalse = true;
      } catch (error) {
        // Toast(error.message);
      }
    },
    embryoDetails(item) {
      let param = {
        name: "embryoDetails",
        cdnaChange: item.cdnaChange,
        geneName: item.geneName,
        type: "",
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
      // console.log(item);
      // let params = {
      //   cdnaChange: item.cdnaChange,
      //   geneName: item.geneName,
      //   labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
      //   productId: this.publicParams.productId,
      // };
      // this.setParams(params);
      // this.$router.push({
      //   name: "embryoDetails",
      //   query: {
      //     sessionId: this.$route.query.sessionId,
      //   },
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.Alk {
  background: @background_color;
  margin-bottom: 20px;
  font-family: @family;
  border-bottom: 1px solid #e3e5e8;
  margin-bottom: 20px;
  padding-bottom: 20px;
  &:nth-last-child(2) {
    border: 0;
  }
  .content {
    .text-content-alk {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .result {
        color: #28d4e5;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #2f354d;
        line-height: 18px;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 17px;
        margin-bottom: 4px;
      }
    }
    h1 {
      font-size: 15PX;
      padding-left: 12px;
      font-weight: 500;
      color: #27ca8d;
      line-height: 22px;
      position: relative;
      margin-bottom: 20px;
      &::before {
        content: "";
        position: absolute;
        width: 3px;
        left: 0;
        top: 50%;
        margin-top: -7px;
        height: 14px;
        background: #27ca8d;
        border-radius: 2px;
      }
    }
  }
  .title {
    font-size: 15PX;
    font-family: @family;
    font-weight: 500;
    color: #4b84ff;
    position: relative;

    line-height: 22px;
    position: relative;
    padding-left: 16px;
    margin-bottom: 20px;
    &::before {
      content: "";
      position: absolute;
      width: 3px;
      left: 0;
      top: 50%;
      margin-top: -7px;
      height: 14px;
      background: #4b84ff;
      border-radius: 2px;
    }
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.openStyle {
  text-align: center;
  height: 40px;
  font-size: 12px;
  font-weight: 400;
  color: #4b84ff;
  line-height: 40px;
  border-bottom: 1px solid #e3e5e8;
  i {
    color: #4b84ff;
    font-size: 12px;
  }
}
.openClass {
  overflow: hidden;
  height: 70px !important;
  transition: height 1s;
}
.relevant {
  height: auto;
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  ._btn {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 10px;

    button {
      width: 136px;
      height: 32px;
      background: linear-gradient(270deg, #60adff 0%, #4b84ff 100%);
      box-shadow: 0px 4px 10px 0px rgba(75, 132, 255, 0.2);
      border-radius: 16px;
      outline: none;
      border: 0;
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #ffffff;
      margin-left: 12px;
      i {
        font-size: 10px;
      }
    }
  }
  .text-content {
    padding: 0 24px;
    font-size: 13px;
    font-weight: 400;
    color: #2f354d;
    line-height: 24px;
    /deep/.van-loading__text {
      color: #4b84ff;
    }
    /deep/.van-loading__spinner {
      color: #4b84ff;
    }
    .null-p {
      padding-bottom: 30px;
    }
    .byData {
      border-bottom: 1px solid #e3e5e8;
      margin-bottom: 30px;
      &:nth-last-child(2) {
        // border: 0;
        margin: 0;
      }

      .flex-content {
        display: flex;
        .l,
        .r {
          width: 50%;
        }
        .l {
          div {
            margin-bottom: 20px;
          }
        }
        .r {
          div {
            margin-bottom: 26px;
          }
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #a4a9bf;
          line-height: 17px;
          margin-bottom: 4px;
        }
        h3 {
          font-size: 13px;
          font-weight: 500;
          color: #2f354d;
          line-height: 18px;
        }
      }
      h2 {
        font-size: 15PX;
        font-weight: 500;
        color: #27ca8d;
        line-height: 22px;
        position: relative;
        padding-left: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #4b84ff;
          line-height: 17px;
          i {
            margin-left: 4px;
            vertical-align: middle;
            margin-bottom: 3px;
          }
        }
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          margin-top: -7px;
          left: 0;
          width: 3px;
          height: 14px;
          background: #27ca8d;
          border-radius: 2px;
        }
      }
    }
  }
  h1 {
    // height: 70px;
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    // line-height: 70px;
    padding: 24px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ts-info {
      color: #a4a9bf;
      // position: absolute;
    }
    i {
      min-width: 16px;
    }
  }
}
</style>
